import { forwardRef } from 'react';

type AppFrameProps = {
  src: string;
  title?: string;
  hidden?: boolean;
  isPrimary?: boolean;
  onLoad: () => void;
};

export const AppFrame = forwardRef<HTMLIFrameElement, AppFrameProps>(function AppFrame(
  { src, title = 'OneSheet application', hidden = false, isPrimary = false, onLoad },
  ref,
) {
  return (
    <iframe
      ref={ref}
      id={isPrimary ? 'alt-y-app-frame' : undefined}
      className="app-frame"
      title={title}
      src={src}
      allow="clipboard-read; clipboard-write"
      onLoad={onLoad}
      style={hidden ? { visibility: 'hidden', pointerEvents: 'none' } : undefined}
      aria-hidden={hidden || undefined}
    />
  );
});
